export default "__VITE_ASSET__CZjYuvHQ__"